const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

const BASE_URL = process.env.REACT_APP_BASE_URL

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export const APIGetUserAreas = async (): Promise<{status: boolean, data: string[], message: string}> => {
    const URL: string = `${BASE_URL}/identity_manager/api/v1/getUserAreas`
    const HEADER: RequestInit = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseData: ResponseTypes = await response.json() as ResponseTypes

        if (!response.ok)
        {
            return {status: false, data: [], message: responseData.message}
        }
        return { status: true, data: responseData.data as string[], message: 'user areas found'}
    }
    catch(err)
    {
        console.error(`error getting user areas with error with error [${err}]`)
        return { status: false, data: [], message: 'failed to get user areas'}
    }
}